<template>
    <div :class="[$style['mortgage-calc'], {[$style['is-loading']]: isLoading}]" id="mortgage-calc" ref="mortgage-calc">
        <transition name="fade" mode="out-in">
            <div v-if="isLoading" key="loading" :class="$style['mortgage-calc__loading']">
                <svg width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#937545" opacity="0.5" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                </svg>
            </div>

            <div v-else key="content" :class="$style['mortgage-calc__wrapper']">
                <div :class="$style['mortgage-calc__filter']" data-sticky-container>
                    <div :class="$style['mortgage-calc__title']">Расчет ипотеки</div>

                    <FilterCalc :filter="filter"
                                :tabs="tabs"
                                :personLink="links.personData"
                                :sendData="sendData"
                                :isPriceChanged="isPriceChange"
                                :isPayChanged="isPayChange"
                                :isTermChanged="isTermChange"
                                :update="update"
                                ref="filter"
                                @changePrice="isPriceChange = true"
                                @changePay="isPayChange = true"
                                @changeTerm="isTermChange = true"
                                @changeTab="changeTab"
                                @change="changeFilter"
                                @noResult="clearList"
                                @safeHistory="safeHistory"
                                @toUpdate="toUpdate"
                    />
                </div>

                <div :class="$style['mortgage-calc__content']" id="mortgage-calc-top">
                  <div :class="$style['mortgage-calc__content-top']">
                        <Top :personLink="links.personData"
                             :share="share"
                             :satisfyProgram="satisfyProgram"
                             :level="level"
                             :programs="programs"
                             @getPdfLink="getPdfLink" />
                        <Objects v-if="hasActivePrograms(programs) && isLevelAll(level)"
                                 :objects="objects" />
                    </div>

                    <div :class="[$style['mortgage-calc__content-list'], {'list_theme_all': isLevelAll(level)}]" id="mortgage-calc-list" data-sticky-container>
                        <List :programs="programs"
                              :typeNoResult="typeNoResult"
                              :personLink="links.personData"
                              :sendData="sendData"
                              :filter="filter"
                              @resetFilter="resetFilter" />

                        <ShareScroll :personLink="links.personData"
                                     :share="share"
                                     :level="level"
                                     @getPdfLink="getPdfLink" />
                    </div>

                    <More v-if="loadMore"
                          @click="toLoadMore">{{ loadMore }}</More>
                </div>
            </div>
        </transition>

        <Popup ref="popup">
            <ConfirmTab :tab="tabConfirm"
                        :complex="complexConfirm"
                        @success="changeTabConfirm"
                        @error="$refs.popup.close()"/>
        </Popup>
    </div>
</template>

<script>
    import FilterCalc from './components/FilterCalc/FilterCalc';
    import List from './components/List/List';
    import More from './components/More/More';
    import Top from './components/Top/Top';
    import Popup from './components/Popup/Popup';
    import ConfirmTab from './components/ConfirmTab/ConfirmTab';
    import ShareScroll from './components/ShareScroll/ShareScroll';
    import Objects from './components/Objects/Objects';

    import axios from 'axios';
    import VueScrollTo from 'vue-scrollto';
    import History from './helpers/History';
    import Utils from './helpers/Utils';
    require('formdata-polyfill');

    export default {
        components: {
            FilterCalc,
            List,
            More,
            Top,
            Popup,
            ConfirmTab,
            ShareScroll,
            Objects
        },

        data() {
            return {
                tabs          : {}, // Объект табов (инитится только при первом запросе)
                filter        : {}, // Объект фильтра (слайдеров и селектов)
                satisfyProgram: {}, // информация о том сколько ипотечных программ подходит под фильтр
                programs      : [], // Массив с программами ипотеки
                sendData      : new FormData(), // Отправные данные
                isPriceChange : Utils.getUrlParams('isPriceChange') === 'true' || false, // флаг, редактировался ли Стоимость квартиры
                isPayChange   : Utils.getUrlParams('isPaymentChange') === 'true' || false, // флаг, редактировался ли Первый взнос
                isTermChange  : Utils.getUrlParams('isTermChange') === 'true' || false, // флаг, редактировался ли срок сдачи
                isLoading     : true, // Прелоадер всего калькулятора
                loadMore      : false, // Кнопка загрузить еще, если false не выводится
                tabConfirm    : null, // Объект Таба для подтверждения перехода
                complexConfirm: null, // Объект Комплекса для подтверждения перехода
                typeNoResult  : 'base', // Тип вывода блока "нет результата" (base || pay || price || smallPay || largePay)
                links         : {}, // Сторонние ссылки (инитится только при первом запросе)
                share         : {}, // Данные об "поделиться"
                level         : null, // уровень калькулятора: все программы, ЖК, квартира (all || object || flat),
                objects       : [],  // Список объектов, у которых есть ипотечная программа нужного типа
                saveData      : {},
                update        : true // Флаг, показывающий, обновляем ли выдачу после загрузки данных - обычно да
            }
        },
        methods: {
            /**
             *
             * @param {string} typeRequest - first|tab
             */
            send(typeRequest = '') {
                if (typeRequest === 'first') {
                    this.isLoading = true;
                    this.sendData = History.getFormData();
                    this.addMainDataset(this.sendData);
                } else if (typeRequest === 'reset') {
                    const activeTab = History.get('tabs');
                    History.clear();
                    this.sendData = new FormData();
                    if (activeTab) {
                        this.sendData.append('tabs', activeTab);
                    }
                    this.addMainDataset(this.sendData);
                } else {
                    this.collectData();
                    this.addMainDataset(this.sendData);
                    this.safeHistory();
                }

                // scroll top
                if (typeRequest !== 'more' && typeRequest !== 'first' && window.innerWidth >= 960) {
                    const bound = this.$refs['mortgage-calc'].getBoundingClientRect();

                    if (bound.top < -50) {
                        this.scrollTop();
                    }
                }

                axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                axios.post('/ajax/mortgage/mortgage-calculator.php', this.sendData)
                    // axios.post('/tests/mortgage/mortgage.php', this.sendData) // подключение тестовых данных
                    .then((response) => {
                        const {data} = response;
                        // duplicate object
                        this.saveData = JSON.parse(JSON.stringify(data));

                        if (typeRequest === 'more') {
                            this.programs.push(...data.programs);

                        } else if (typeRequest !== 'first' &&  typeRequest !== 'reset' && typeRequest !== 'more') {
                            this.level = data.level;
                            this.satisfyProgram = data.satisfyProgram;

                            if (this.update) {
                                this.programs = data.programs || [];
                                this.objects = data.objects;
                            }

                        } else if (typeRequest === 'first' || typeRequest === 'reset') {
                            this.tabs = data.tabs;
                            this.socials = data.socials || {};
                            this.share = data.share || {};
                            this.level = data.level;
                            this.satisfyProgram = data.satisfyProgram;

                            if (this.update) {
                                this.programs = data.programs || [];
                                this.objects = data.objects;
                            }

                            setTimeout(() => {
                                this.collectData();
                                this.addMainDataset(this.sendData);
                            }, 0);

                        }

                        this.filter = data.filter;
                        this.loadMore = data.loadMore || false;
                        this.links = data.links || {};
                    })
                    .catch((error) => {
                        console.error(error); // eslint-disable-line
                    })
                    .then(() => {
                        this.isLoading = false;
                    });
            },

            collectData() {
                const data = new FormData();
                let nameBuild = 'building';

                if (this.filter.sliders) {
                    if (this.filter.sliders.price) {
                        data.append(this.filter.sliders.price.name, this.filter.sliders.price.value);
                        data.append('isPriceChange', this.isPriceChange);
                    }

                    if (this.filter.sliders.pay) {
                        data.append(this.filter.sliders.pay.name, this.filter.sliders.pay.value);
                        data.append('isPaymentChange', this.isPayChange);
                    }

                    if (this.filter.sliders.term) {
                        data.append(this.filter.sliders.term.name, this.filter.sliders.term.value);
                        data.append('isTermChange', this.isTermChange);
                    }
                }

                if (this.$refs.filter) {
                    const building = this.$refs.filter.getBuilding();

                    if (building) {
                        building.options.forEach((option) => {
                            if (option.selected) {
                                data.append(`${building.name}[]`, option.value);
                                nameBuild = building.name;
                            } else {
                                History.remove(`${nameBuild}`);
                            }
                        });
                    } else {
                        History.remove(`${nameBuild}`);
                    }
                }

                if (this.tabs.options) {
                    const active = this.tabs.options.find(tab => tab.selected);

                    if (active) {
                        data.append(this.tabs.name, `${active.id}`);
                    }
                }

                if (this.programs) {
                    data.append('show', `${this.programs.length}`);
                }

                this.sendData = data;
            },

            /**
             * Добавляем data аттрибуты от главного элемента
             * @param {FormData} formData - формдата, куда присваиваются аттрибуты
             */
            addMainDataset(formData) {
                if (this.$dataset) {
                    for(const key in this.$dataset) {
                        if (this.$dataset.hasOwnProperty(key)) {
                            if (!formData.has(key)) {
                                formData.append(key, this.$dataset[key]);
                            }
                        }
                    }
                }
            },

            changeFilter() {
                this.send();
            },

            clearList(type = 'base') {
                this.programs = [];
                this.loadMore = false;
                this.typeNoResult = type;

                window.innerWidth >= 960 && this.scrollTop();
            },

            safeHistory() {
                if (this.filter.sliders && this.filter.sliders.price && this.filter.sliders.price.hide) {
                    this.sendData.delete(this.filter.sliders.price.name);
                    this.sendData.delete('isPriceChange');
                }

                History.appendFromFormData(this.sendData);
            },

            toUpdate(value) {
                this.update = value;
            },

            changeTab() {
                const change = () => {
                    setTimeout(() => {
                        this.send('tab');
                    }, 0);
                };

                change();
            },

            changeTabConfirm(tab) {
                this.$refs.filter.clearErrors();
                this.doActiveTab(tab)
                this.$refs.popup.close();

                this.send('tab');
            },

            doActiveTab(tab) {
                this.tabs.options.forEach((item) => {
                    item.selected = false;
                });

                tab.selected = true;
                this.activeTabComputed = tab;
            },

            toLoadMore() {
                this.send('more');
            },

            resetFilter() {
                this.$refs.filter.resetFilter();

                this.isPayChange = false;
                this.isPriceChange = false;
                this.isTermChange = false;

                this.send('reset');
            },

            scrollTop() {
                VueScrollTo.scrollTo('#mortgage-calc', 500);
            },

            addScriptShare() {
                [
                    'https://yastatic.net/share2/share.js',
                    'https://yastatic.net/es5-shims/0.0.2/es5-shims.min.js'
                ].forEach((src) => {
                    const script = document.createElement("script");

                    script.type = "text/javascript";
                    script.src = src;
                    this.$el.insertAdjacentElement('beforeend', script);
                });
            },

            toggleHeader() {
                const bound = this.$refs['mortgage-calc'].getBoundingClientRect();
                const offsetTop = 100;
                const offsetBottom = 0;

                if (bound.top < offsetTop && bound.bottom > offsetBottom) {
                    this.header.style.position = 'relative';
                } else {
                    this.header.style.position = 'fixed';
                }
            },

            getPdfLink() {
                const formData = this.sendData;
                formData.append('programs', JSON.stringify(this.programs));

                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.open('POST', '/api/pdf', true);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE version
                            const pdf = new Blob([xhr.response], {
                                type: 'application/pdf'
                            });
                            window.navigator.msSaveBlob(pdf, 'test.pdf');
                        } else if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                            // Firefox version
                            const pdf = new File([xhr.response], 'raschet_ipoteki.pdf', {
                                type: 'application/force-download'
                            });
                            window.open(URL.createObjectURL(pdf));
                        } else {
                            // Chrome and other version
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(xhr.response);
                            link.download = 'raschet_ipoteki.pdf';
                            link.click();
                        }
                    }
                };
                xhr.send(formData);
            },

            hasActivePrograms(programs) {
                const result = programs.filter((item) => !item.isDisabled);
                return result.length > 0;
            },

            isLevelAll(level) {
                return level === 'all';
            }
        },

        mounted() {
            this.send('first');

            this.addScriptShare();

            this.header = document.querySelector('.j-header__base');

            if (this.header) {
                window.addEventListener('scroll', Utils.debounce(this.toggleHeader, 50), false);
            }
        },

        destroyed() {
            if (this.header) {
                window.removeEventListener('scroll', Utils.debounce, false);
            }
        }
    }
</script>

<style lang='scss' module>
    @import "./App";
</style>

<style lang='scss'>
    .important-hide {
        visibility: hidden!important;
        z-index: -10 !important;
        opacity: 0 !important;
        top: -10000px !important;
    }

    .fade-enter-active,
    .fade-leave-active {
        @include transition(opacity);
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
